const formatTime = time => {
  const timeNumber = Number.isNaN(time) ? 0 : time;

  return `${Math.floor(timeNumber / 60)}:${`0${Math.floor(
    timeNumber % 60,
  )}`.slice(-2)}`;
};

export default formatTime;
